import React from 'react'
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Team = ({ ToastContainer, subscribeToNewsletters, notify }) => {
  return (
    <div className="overflow-x-hidden">
        <Helmet>
            <title>Vent Africa - Team</title>

            <meta name="description" content="Crypto to Cash Made Easy, Convert your crypto to Cash, Instant Payment, Zero Charge, Download Vent App" />
            <meta name="keywords" content="Crypto, Cash, Bitcoin, BTC, Fiat, Naira, USD, Ethereum, OTC, Trade" />
        </Helmet>
        <Header />
        <ToastContainer />

        <section className="-z-10 pt-36 lg:pt-48 bg-white">
          <div className="max-w-[1500px] mx-auto px-5 lg:px-16 flex flex-col lg:flex-row items-center lg:items-center justify-center gap-16">
            <div className="h-full relative">
              <span className='bg-[#24A873] text-white text-center rounded-full text-xs font-light tracking-tight px-6 absolute top-[40px] lg:top-[-10px] lg:left-[376px]'>Curious Kinds</span>

              <span className='bg-[#2CB8F2] text-white text-center rounded-full text-xs font-light tracking-tight px-6 absolute top-[90px] left-[38px] lg:top-[40px] lg:left-[40px]'>Focused Visionaries</span>

              <span className='bg-[#FF6E40] text-white text-center rounded-full text-xs font-light tracking-tight px-6 absolute top-[185px] left-[25px] lg:top-[90px] lg:left-[265px]'>Super-powers</span>

              <p className="text-3xl max-w-[100%] lg:max-w-[690px] lg:mr-auto mb-10 leading-[1.6] tracking-tight uppercase">
                A team of super-humans playing as a one! collaborative supportive, cross-functional and Disciplined to the core for the Vent Mission.
              </p>
              <img src="img/Rectangle 996.png" alt="" className="w-full hidden sm:block lg:block" />
              <img src="img/Rectangle 1001.png" alt="" className="w-full inline sm:hidden lg:hidden" />
            </div>
            <div className="bg-[#F6F8F9] p-5">
              <img src="img/TeamAttributes.png" alt="" />
            </div>
          </div>
        </section>

        {/* Still under review from COO */}
        <section className="py-24">
          <div className="max-w-[1500px] mx-auto px-5 lg:px-16">
            <div className="flex justify-center">
              <p className="text-[#05364D] text-sm tracking-tight mb-5 px-5 py-3 rounded-full border border-gray-100">OUR VISION
              </p>
            </div>
            <div className="text-center lg:max-w-[700px] mx-auto mb-3">
              <p className="text-2xl sm:text-3xl lg:text-4xl text-[#05364D] tracking-tight uppercase">Here is our spontaneous drive.</p>
            </div>

            <div className="flex flex-col lg:flex-row justify-center gap-10 max-w-[600px] mx-auto">
              <div>
                <p className="text-gray-500 text-center mb-10">To provide a seamless and accessible gateway for individuals & businesses to utilize their cryptocurrency assets in the real world.</p>
                <div className='mb-7'>
                  <img src="img/male-employee-getting-used-his-new-office-job-along-with-female-colleagues.jpg" className="w-full" alt="Display" />
                </div>
              </div>

              {/* <div className="max-w-[470px] flex flex-col gap-6">
                <p className="text-gray-500">Welcome to Vent Africa, where our vision is to bridge the gap between the digital and
                  traditional financial
                  realms. We envision a future where seamless crypto to fiat liquidity becomes a reality for everyone. With
                  our cutting-edge platform, we empower individuals and businesses to effortlessly convert their
                  cryptocurrencies into tangible cash, opening doors to limitless financial possibilities.
                </p>

                <p className="text-gray-500">At SynthiTrade, we believe in a world where crypto assets are easily accessible, and
                  their value can be
                  realized at any given moment. We strive to provide a secure, transparent, and user-friendly environment that
                  ensures swift and reliable transactions. Our vision is to be the go-to platform for individuals and
                  businesses seeking seamless liquidity, enabling them to navigate the dynamic crypto landscape with
                  confidence and ease.
                </p>

                <p className="text-gray-500">Join us on this exciting journey as we redefine the future of crypto to fiat
                  liquidity. Together, we will
                  build a world where digital and traditional finance seamlessly coexist, fostering financial freedom and
                  empowerment for all. Experience the vision of SynthiTrade and embark on a transformative financial adventure
                  today!
                </p>
                <p className="text-gray-500 lg:hidden">Join us on this exciting journey as we redefine the future of crypto to
                  fiat liquidity.
                  Together, we will
                  build a world where digital and traditional finance seamlessly coexist, fostering financial freedom and
                  empowerment for all. Experience the vision of SynthiTrade and embark on a transformative financial adventure
                  today!
                </p>
              </div> */}
            </div>
          </div>
        </section>

        <section className="pb-24">
          <div className="max-w-[1500px] mx-auto px-5 lg:px-16">
            <div className="flex justify-center">
              <p className="text-[#05364D] text-sm tracking-tight mb-5 px-5 py-3 rounded-full border border-gray-100">OUR MISSION
              </p>
            </div>
            <div className="text-center lg:max-w-[700px] mx-auto mb-5">
              <p className="text-2xl sm:text-3xl lg:text-4xl  text-[#05364D] tracking-tight uppercase">We are strategic WITH the path TO ACTUALISE the
                Mission.</p>
            </div>

            <div className="flex flex-col items-center max-w-[600px] mx-auto gap-5">
              <p className="text-gray-500">
                To create a seamless, user-friendly platform that allows anyone, regardless of location or knowledge of cryptocurrency, to quickly and safely convert their digital assets into fiat currency and purchase real-world goods and services.
              </p>
              {/* <p className="text-gray-500">
                <span className="text-black">
                  At SynthiTrade, our mission is to empower individuals and businesses by providing seamless crypto to fiat
                  liquidity solutions. We are driven by a commitment to revolutionize the way people perceive and utilize
                  digital assets, creating a bridge between the world of cryptocurrencies and traditional finance.
                  Our primary focus is to offer a reliable, secure, and user-centric platform that simplifies 
                </span> 
                &nbsp; the process of converting cryptocurrencies into tangible cash. We aim to break down barriers and eliminate the
                complexities that often hinder individuals from fully utilizing the value of their digital assets.
                We strive to foster financial inclusion by offering accessible liquidity solutions to individuals and
                businesses alike. Whether it's a casual trader looking to liquidate their crypto holdings or a business
                seeking efficient payment solutions, our mission is to provide a seamless experience that unlocks the true
                potential of digital currencies.
              </p> */}
              <img src="img/team-working.jpg" className="w-full" alt="Display" />
              {/* <p className="text-gray-500">
                In pursuing our mission, we place great emphasis on transparency, integrity, and exceptional customer service.
                We are dedicated to building trust and maintaining a strong relationship with our users. Our team of experts
                is committed to staying at the forefront of technological advancements, continuously enhancing our platform to
                deliver a seamless and secure trading experience.
                Through our mission, we envision a world where anyone can easily navigate the crypto landscape, convert their
                digital assets into fiat currencies, and embrace the vast opportunities offered by decentralized finance. We
                are passionate about empowering individuals to take control of their financial futures, enabling them to
                thrive in the digital economy.
                Join us as we embark on this transformative mission to redefine crypto to fiat liquidity.
              </p> */}
            </div>
            <div className=" border-b border-zinc-100 my-6"></div>
            <div className="max-w-[800px] mx-auto">
              <p className="text-center text-gray-400">
                Together, we will shape a future where financial empowerment and innovation go hand in hand, enabling
                individuals and businesses to thrive in the ever-evolving world of digital finance.
              </p>
            </div>
          </div>
        </section>

        <section className="py-24">
          <div className="max-w-[1500px] mx-auto px-5 lg:px-16">
            <div className="flex justify-center">
              <p className="text-[#05364D] text-sm tracking-tight mb-5 px-5 py-3 rounded-full border border-gray-100">THE TEAM</p>
            </div>
            <div className="text-center lg:max-w-[1000px] mx-auto mb-16">
              <p className="text-2xl sm:text-3xl lg:text-4xl  text-[#05364D] tracking-tight uppercase">Meet the super humans Pioneering the vision</p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-10">
              <div className="flex flex-col items-center text-center">
                <img src="img/Sample_3.png" alt="" className="max-w-[150px]" />
                <p className="text-xs mt-3 text-gray-400">CEO/CTO</p>
              </div>
              <div className="flex flex-col items-center text-center">
                <img src="img/Sample_8.png" alt="" className="max-w-[150px]" />
                <p className="text-xs mt-3 text-gray-400">COO</p>
              </div>
              <div className="flex flex-col items-center text-center">
                <img src="img/Sample_1.png" alt="" className="max-w-[150px]" />
                <p className="text-xs mt-3 text-gray-400">CFO</p>
              </div>
              <div className="flex flex-col items-center text-center">
                <img src="img/Sample_2.png" alt="" className="max-w-[150px]" />
                <p className="text-xs mt-3 text-gray-400">HEAD OF ADMIN</p>
              </div>
              <div className="flex flex-col items-center text-center">
                <img src="img/Sample_5.png" alt="" className="max-w-[150px]" />
                <p className="text-xs mt-3 text-gray-400">Social Media Manager</p>
              </div>
              <div className="flex flex-col items-center text-center">
                <img src="img/Sample_6.png" alt="" className="max-w-[150px]" />
                <p className="text-xs mt-3 text-gray-400">ADMIN</p>
              </div>
              <div className="flex flex-col items-center text-center">
                <img src="img/Sample_7.png" alt="" className="max-w-[150px]" />
                <p className="text-xs mt-3 text-gray-400">SOFTWARE ENGINEER</p>
              </div>
              <div className="flex flex-col items-center text-center">
                <img src="img/Sample_8.png" alt="" className="max-w-[150px]" />
                <p className="text-xs mt-3 text-gray-400">PRODUCT DESIGNER</p>
              </div>
              <div className="flex flex-col items-center text-center">
                <img src="img/Sample_9.png" alt="" className="max-w-[150px]" />
                <p className="text-xs mt-3 text-gray-400">ADMIN</p>
              </div>
              <div className="flex flex-col items-center text-center">
                <img src="img/Sample_10.png" alt="" className="max-w-[150px]" />
                <p className="text-xs mt-3 text-gray-400">HEAD OF CUSTOMER SUPPORT</p>
              </div>
              <div className="flex flex-col items-center text-center">
                <img src="img/Sample_6.png" alt="" className="max-w-[150px]" />
                <p className="text-xs mt-3 text-gray-400">CUSTOMER SUPPORT</p>
              </div>
              <div className="flex flex-col items-center text-center">
                <img src="img/Sample_2.png" alt="" className="max-w-[150px]" />
                <p className="text-xs mt-3 text-gray-400">CUSTOMER SUPPORT</p>
              </div>
              <div className="flex flex-col items-center text-center">
                <img src="img/Sample_3.png" alt="" className="max-w-[150px]" />
                <p className="text-xs mt-3 text-gray-400">ADMIN</p>
              </div>
              <div className="flex flex-col items-center text-center">
                <img src="img/Sample_8.png" alt="" className="max-w-[150px]" />
                <p className="text-xs mt-3 text-gray-400">VISUAL DESIGNER</p>
              </div>
              <div className="flex flex-col items-center text-center">
                <img src="img/Sample_4.png" alt="" className="max-w-[150px]" />
                <p className="text-xs mt-3 text-gray-400">DIGITAL MARKETER</p>
              </div>
              <div className="flex flex-col items-center text-center">
                <img src="img/Sample_8.png" alt="" className="max-w-[150px]" />
                <p className="text-xs mt-3 text-gray-400">Head of Media/Marketing and Content</p>
              </div>
            </div>
          </div>
        </section>

        <Footer onSubscribeToNewsletters={subscribeToNewsletters} onNotify={notify} />
    </div>
  )
}

export default Team;